export var timeOfTheWorkingDay = "05:00";
export var TAX_FEE = 0.1;
export var TAX_LABEL = '10%';
export var TicketStatusKey = {
  PENDING: "pending",
  CLOSED: "closed",
  INVESTIGATING: "investigating",
  AWAITING_RESPONSE: "awaiting_response",
  OTHER: "other"
};
export var TicketStatusValue = {
  PENDING: "در انتظار پاسخ اپراتور",
  CLOSED: "بسته شده",
  INVESTIGATING: "در حال پیگیری",
  AWAITING_RESPONSE: "در انتظار پاسخ کاربر",
  OTHER: "نامشخص"
};
export var DepartmentKey = {
  TECHNICAL: 'technical',
  FINANCIAL: 'financial',
  SUPERVISION: 'supervision',
  OTHER: "other"
};
export var DepartmentValue = {
  TECHNICAL: 'پشتیبانی فنی',
  FINANCIAL: 'امور مالی و حسابداری',
  SUPERVISION: 'واحد نظارت و اطلاع رسانی',
  OTHER: "نامشخص"
};